import React, { useEffect, useRef, useState } from "react";
import api from "src/api"; // Assuming you have created an Axios instance named 'api'
import { Button, FormGroup, Input, Label, Select } from "src/components/utils";
import Category from "src/models/app/Category";
import { toast } from "react-toastify";

const CategoryManagementPage: React.FC = () => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [formData, setFormData] = useState<Category>({
    id: 0,
    name: "",
  });
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await api.get("/categories");
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!formData.name) {
      toast.error("Please fill the category name");
      return;
    }

    try {
      if (formData.id) {
        await api.put(`/admin/categories/${formData.id}`, formData);
        toast.success("Category updated successfully");
      } else {
        await api.post("/admin/categories", formData);
        toast.success("Category created successfully");
      }
      fetchCategories();
      resetForm();
    } catch (error) {
      console.error("Error saving category:", error);
    }
  };

  const handleEdit = (category: Category) => {
    setFormData(category);
    if (containerRef.current) {
      containerRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }  
  };

  const handleDelete = async (categoryId: number) => {
    try {
      await api.delete(`/admin/categories/${categoryId}`);
      toast.success("Deleted successfully.")
      fetchCategories();
    } catch (error) {
      console.error("Error deleting category:", error);
    }
  };

  const resetForm = () => {
    setFormData({
      id: 0,
      name: "",
    });
  };

  return (
    <div className="container" ref={containerRef}>
      <h1>Category Management</h1>

      <div className="table-responsive">
        <table className="mt-5 table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {categories.map((category) => (
              <tr key={category.id}>
                <td>{category.id}</td>
                <td>{category.name}</td>
                <td className="d-flex align-items-center">
                  <Button onClick={() => handleEdit(category)}>Edit</Button>
                  {/* <Button
                    className="ms-3 btn-outline-danger"
                    onClick={() => handleDelete(category.id)}
                  >
                    Delete
                  </Button> */}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <hr />

      <form onSubmit={handleSubmit}>
        <FormGroup
          label="Name"
          required
          formField={
            <Input
              name="name"
              onChange={handleInputChange}
              value={formData.name}
            />
          }
        />

        <div className="my-5">
          <Button type="submit">
            {formData.id ? "Update Category" : "Create Category"}
          </Button>
          <Button
            type="button"
            className="btn-outline-secondary ms-3"
            onClick={resetForm}
          >
            Reset
          </Button>
        </div>
      </form>
    </div>
  );
};

export default CategoryManagementPage